var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-image"},[_c('div',{staticClass:"ui-image-pane",class:{vignette: _vm.vignette}},[_c('div'),_c('div',{staticStyle:{"margin-bottom":"15px"}},[_c('h1',[_vm._t("subtitle",function(){return [_vm._v(_vm._s(_vm.title))]})],2),_vm._t("subtitle",function(){return [_c('h2',[_vm._v(_vm._s(_vm.subtitle))])]})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }